import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const [confirming, setConfirming] = useState(true);
  const navigate = useNavigate();

  const handleConfirm = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleCancel = () => {
    navigate(-1); // go back to previous page
  };

  if (!confirming) return null;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      padding: '1rem',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '1.5rem',
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: '420px',
        textAlign: 'center',
        boxShadow: '0 25px 50px rgba(0,0,0,0.4)',
        color: 'white',
      }}>

        {/* Icon */}
        <div style={{
          width: '70px',
          height: '70px',
          borderRadius: '50%',
          background: 'rgba(239,68,68,0.15)',
          border: '2px solid rgba(239,68,68,0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '2rem',
          margin: '0 auto 1.5rem',
        }}>
          🚪
        </div>

        {/* Title */}
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: 700,
          marginBottom: '0.75rem',
          color: '#f1f5f9',
        }}>
          Sign Out
        </h2>

        {/* Message */}
        <p style={{
          color: '#94a3b8',
          fontSize: '0.95rem',
          lineHeight: 1.6,
          marginBottom: '0.5rem',
        }}>
          Are you sure you want to log out of
        </p>
        <p style={{
          color: '#3b82f6',
          fontWeight: 600,
          fontSize: '1rem',
          marginBottom: '2rem',
        }}>
          Recovery Vault?
        </p>

        {/* Security note */}
        <div style={{
          background: 'rgba(59,130,246,0.08)',
          border: '1px solid rgba(59,130,246,0.2)',
          borderRadius: '0.75rem',
          padding: '0.75rem 1rem',
          marginBottom: '2rem',
          fontSize: '0.82rem',
          color: '#94a3b8',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          textAlign: 'left',
        }}>
          <span style={{ fontSize: '1rem', flexShrink: 0 }}>🔒</span>
          Your session will be securely terminated and all local data cleared.
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button
            onClick={handleCancel}
            style={{
              flex: 1,
              padding: '0.85rem',
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '0.75rem',
              color: '#cbd5e1',
              fontWeight: 600,
              fontSize: '0.95rem',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.14)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            style={{
              flex: 1,
              padding: '0.85rem',
              background: 'linear-gradient(135deg, #ef4444, #dc2626)',
              border: 'none',
              borderRadius: '0.75rem',
              color: 'white',
              fontWeight: 600,
              fontSize: '0.95rem',
              cursor: 'pointer',
              transition: 'transform 0.15s, box-shadow 0.2s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(239,68,68,0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Yes, Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}

export default Logout;